<template>
	<div class="h-100 row align-items-center justify-content-center">
		<div class="col h-100 w-100">
			<div :style="backgroundImage" class="background-image h-100 w-100"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ScreensaverImage",
	props: {
		imageUrl: String,
	},
	computed: {
		backgroundImage() {
			return `background-image: url(${this.imageUrl})`; //background-image: url(../img/logo.svg);
		},
	},
};
</script>

<style scoped>
.logo-offset {
	margin-left: 500px;
	margin-right: 50px;
}

.background-image {
	background-size: cover;
	background-position: 50%;
	background-repeat: no-repeat;
}
</style>